<div class="document-wrapper">
  <app-document-viewer [canDelete]="canDelete"></app-document-viewer>
  <app-document-aside *ngIf="!isGrid"></app-document-aside>
</div>
